import { useAuth } from "@/lib/config/auth-provider";

/**
 * Conversation model picker.
 *
 * The server decides entitlement (flag on OR the fairgen_internal tier) and puts the
 * result on `user.featureFlags.conversationModel`; this is the frontend read of that
 * one key, same shape as `useSkillsCustomizationEnabled`.
 */
export function useConversationModelEnabled(): boolean {
  const { user } = useAuth();
  return user?.featureFlags?.conversationModel === true;
}
